import { render, staticRenderFns } from "./mx-mode-widget.vue?vue&type=template&id=4d6b3ec7&scoped=true&"
import script from "./mx-mode-widget.vue?vue&type=script&lang=js&"
export * from "./mx-mode-widget.vue?vue&type=script&lang=js&"
import style0 from "./mx-mode-widget.vue?vue&type=style&index=0&id=4d6b3ec7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6b3ec7",
  null
  
)

export default component.exports